import { DraftPreviewProvider } from './DraftPreviewProvider';
import { Root } from './Root';
export function DraftPreview(props) {
    const { composerId } = props;
    return (<DraftPreviewProvider composerId={composerId}>
      <Root />
    </DraftPreviewProvider>);
}
